import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { EightDTemplate } from './eightDTemplate.slice';
import styles from './EightDTemplate.module.scss';
import { isStringNullOrEmpty } from '../Annotation/AnnotationForm/Utils';

type Props = {
  loading: boolean;
  selectedEightDTemplate?: EightDTemplate;
  onHideModal: () => void;
  onSubmit: (template: EightDTemplate) => void;
};

const EightDTemplateForm = ({ loading, selectedEightDTemplate, onHideModal, onSubmit }: Props) => {
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (selectedEightDTemplate) {
      setCode(selectedEightDTemplate.code);
      setDescription(selectedEightDTemplate.description);
    }
    return () => {
      setCode('');
      setDescription('');
    };
  }, [selectedEightDTemplate]);

  const handleSubmit = () => {
    const model: EightDTemplate = {
      id: selectedEightDTemplate?.id,
      code,
      description,
      canDelete: false,
      canUpdate: false,
      deprecated: false
    };
    onSubmit(model);
  };

  const disabled = isStringNullOrEmpty(code);
  const canRename = !selectedEightDTemplate || (selectedEightDTemplate && selectedEightDTemplate.canUpdate);

  return (
    <Modal
      title='8D Template'
      visible={true}
      onCancel={onHideModal}
      footer={[
        <Button key='save' onClick={handleSubmit} loading={loading} disabled={disabled}>
          Save
        </Button>,
        <Button key='back' onClick={onHideModal}>
          Cancel
        </Button>
      ]}
    >
      <div>
        <Form.Item label='Code' className={styles.antFormItem} required>
          <Input readOnly={!canRename} placeholder='Enter code' value={code} onChange={e => setCode(e.target.value)} />
        </Form.Item>
        <Form.Item label='Description' className={styles.antFormItem}>
          <Input.TextArea
            placeholder='Enter description'
            value={description}
            onChange={e => {
              setDescription(e.target.value);
            }}
          />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default EightDTemplateForm;
